// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1aePl","list":"BalanceDue_list__3RJn5","listRow":"BalanceDue_listRow__13XwQ","total":"BalanceDue_total__1NE5Q"};